<div class="w-full h-full overflow-y-auto page-container">
    <router-outlet *ngIf="true"></router-outlet>
</div>